import { AsyncComboBox, type ComboBoxOption } from '../../../cdl/ComboBox/ComboBox';
import { getSupplierGroups, type GetSupplierGroupsParams } from '../../api/clients/company.api';
import { getSupplierGroup } from '../../api/clients/supplierGroups.api';
import { queries } from '../../api/queryKeys/queries';
import type { AsyncSingleSelectProps } from '../AsyncSelectProps';

export interface SupplierGroupSelectProps extends AsyncSingleSelectProps {
    onChange: (supplierGroupId: string | null) => void;
    value: string | null;
}

const loadSupplierGroupOptions = async (params: GetSupplierGroupsParams): Promise<ComboBoxOption[]> => {
    const supplierGroups = await getSupplierGroups(params);

    return supplierGroups.map((supplierGroup) => ({
        value: supplierGroup.id,
        label: supplierGroup.name,
    }));
};

const loadSupplierGroupOption = async (supplierGroupId: string): Promise<ComboBoxOption | null> => {
    const supplierGroup = await getSupplierGroup(supplierGroupId);

    return {
        value: supplierGroup.id,
        label: supplierGroup.name,
    };
};

export function SupplierGroupSelect({ value, onChange, ...rest }: SupplierGroupSelectProps) {
    return (
        <AsyncComboBox
            {...rest}
            value={value || null}
            onChange={onChange}
            optionsQueryKey={(search) => queries.supplierGroups.comboBoxOptions({ searchQuery: search }).queryKey}
            optionsQueryFn={(search) => loadSupplierGroupOptions({ searchQuery: search })}
            selectedOptionQueryKey={(selectedValue) =>
                queries.supplierGroups.selectedComboBoxOption(selectedValue).queryKey
            }
            selectedOptionQueryFn={loadSupplierGroupOption}
        />
    );
}
